import React, { useEffect, useState } from 'react';
import MigaPan from '../../../app/orussystem/component/MigaPan';
import { useLocation, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { PanelUserDetailStyle } from '../../UserDetails/PanelUserDetailStyle';
import { DATE_INIT, DATE_END } from '../../../app/api-client/constants';
import { UtilsDate } from '../../../app/orussystem/utils/UtilDate';
import DetalleUser from '../GeneriBascula.js/detalleUser';
import FiltroDate from './filtroDate';
import { getUsersAlcoholimetriaReporte } from '../../domain/api/AlcoholimetriaApi';
import { useDispatch } from 'react-redux';
import ListHistorialAlc from './ListHistorialAlc';
import clsx from 'clsx';
import {
  Grid,
  Paper,
  Table,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  useTheme
} from '@material-ui/core';
import { panelUsersAuthStyle } from '../../users_auth/panelUsersAuthStyle';


export const Reporte = (params) => {
  const classes = PanelUserDetailStyle();
  const fixedHeightFilter = clsx(classes.paper, classes.fixedHeightFilter);
  const [nameBascula] = useState("");
  const [page, setPage] = useState(0)
  const [size] = useState(10)
  const [totalElements, settotalElements] = useState(0)
  let { id } = useParams();
  const idBascula = id === undefined || id === null || id === ":id" || id === "poll" ? 0 : id;
  let init_date = localStorage.getItem(DATE_INIT);
  let end_date = localStorage.getItem(DATE_END);
  const [dateEnd, setDateEnd] = useState(end_date);
  const [dateInit, setDateInit] = useState(init_date);
  const [isLoadUser, setIsLoadUser] = useState(false);
  const [userPhone, setuserPhone] = useState("");
  const [userCedula, setuserCedula] = useState("");
  const [infoBascula] = useState({ maxUser: 0, genero: [], genericIESs: [] });
  const [UsersMachine, setUsersMachine] = useState([]);
  const dispatch = useDispatch();
  const location = useLocation();
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const clases = panelUsersAuthStyle()

  const handlerFilter = (dataStart, dataEnd) => {
    setDateEnd(UtilsDate().formatYYYYMMdd(dataEnd));
    setDateInit(UtilsDate().formatYYYYMMdd(dataStart))
    reloadPage(UtilsDate().formatYYYYMMdd(dataStart), UtilsDate().formatYYYYMMdd(dataEnd))
  };


  const getDataTable = async (dataStart, dataEnd, page, size) => {
    const pageBascula = await getUsersAlcoholimetriaReporte(dispatch, idBascula, dataStart, dataEnd, page, 30);

    try {
      setUsersMachine(pageBascula.content);
      setPage(pageBascula.page);
      settotalElements(pageBascula.totalElements);
    } catch (err) {
      console.log("Ocurrio un error", err)
    }
  }

  const reloadPage = (dateInitParam, dateEndParam) => {
    getDataTable(dateInitParam, dateEndParam, "", page)
  }

  //cambio de pagina
  const handleChangePage = (event, newPage) => {
    setPage(newPage)
    getDataTable(dataStart, dataEnd, newPage, rowsPerPage)

  };
  //cambio de tamaño
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value)
    getDataTable(dataStart, dataEnd, 0, event.target.value)


  };
  const { nombre, dataStart, dataEnd, fechainicial, fechafinal } = location.state;
  useEffect(async () => {
    setIsLoadUser(true);
    getDataTable(dataStart, dataEnd, page, rowsPerPage)
    setIsLoadUser(false);
  }, [dataStart, dataEnd, userPhone.length >= 5, userCedula.length >= 5, page, size]);


  const theme = useTheme(); // Obtén el tema

  const primaryColor = theme.palette.primary.main;

  return (
    <>
      <Grid item xs={12} >
        <br></br>
        <br></br>

        <MigaPan
          namePage={`Descargar Reporte`}
          to="/"
          namePage2="Estaciones"
          to2="/basculas/"
          namePage3={`Alcoholimetría ${nombre}`}
          to3={{
            pathname: `/basculas/alcoholimetria/${idBascula}`,
            state: { nombre: nombre }, // Pass nameBascula in the state object
          }}
        >
          Home
        </MigaPan>
      </Grid>

      <Grid item xs={12} md={12} lg={9}>
        <Paper className={fixedHeightFilter} >
          <Grid container spacing={1}>
            <Grid item xs={12} md={12} lg={12}>
              <FiltroDate
                handlerFilter={handlerFilter}
                isLoading={isLoadUser}
                isDate={true}
                reloadTable={reloadPage}
                filter={userPhone}
                filterCedula={userCedula}
                page={page}
                size={size}
                setFilterCedula={setuserCedula}
                setFilter={setuserPhone}
                filtrar={() => { }}
                setDateInit={setDateInit}
                setDateEnd={setDateEnd}
                fechainicial={fechainicial}
                fechafinal={fechafinal}
              />
            </Grid>
          </Grid>
        </Paper>
      </Grid>

      <Grid xs={12} md={12} lg={3}>
        <Paper className={fixedHeightFilter} style={{ maxHeight: "100%", marginTop: "0.8rem" }}>
          <DetalleUser
            max={infoBascula.maxUser}
            dataBascula={nameBascula}
            total={totalElements} />
        </Paper>
      </Grid>

      <Grid item xs={12} md={6} lg={12}>
        <Paper className={classes.paper1}>
          <Typography align="center" style={{ fontWeight: 'bold', fontSize: "26px" }} color='primary'>
            Registro historico
          </Typography>
          <Grid item xs={12} sm container alignItems="center" justifyContent="center" >
            <Typography component="p" align="center">
              {dateInit}
            </Typography>

            <Typography component="p" align="right" style={{ marginLeft: '10px' }}>
              {dateEnd}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            {/* Encabezados de la tabla */}


            <Table>
              <TableHead style={{ color: '#0088FE' }}>
                <TableRow style={{ color: '#0088FE' }}>
                  <TableCell className={clases.TableCell} style={{ paddingLeft: '3%', width: '20%', color: primaryColor }}>Identificacion</TableCell>
                  <TableCell className={clases.TableCell} style={{ paddingLeft: '8%', width: '20%', color: primaryColor }}>Celular</TableCell>
                  <TableCell className={clases.TableCell} style={{ width: '25%', paddingLeft: '7%', color: primaryColor }}>Medición</TableCell>
                  <TableCell className={clases.TableCell} style={{ paddingLeft: '8%', color: primaryColor }}>Fecha</TableCell>
                </TableRow>
              </TableHead>
            </Table>
          </Grid>
          <Grid item xs={12}>
            <ListHistorialAlc
              rows={UsersMachine}
              isLoadUser={isLoadUser}
              fechaIni={dataStart}
              fechaFin={dataEnd}
              pageBascula={UsersMachine}
              page={page}
              size={size}
              totalElement={totalElements}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              setPage={setPage}

            />
          </Grid>
        </Paper>
      </Grid>
    </>
  )
}